import { getAxiosClient } from "../../HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { HttpIntegration } from "./httpIntegration-interface";

export const fetchHttpIntegrationsByApplication = createAsyncThunk(
  "httpIntegration/fetchHttpIntegrationsByApplication",
  async (appUuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(
      `api/http-integration/app-uuid/${appUuid}`
    );
    return response.data as HttpIntegration[];
  }
);

export const fetchHttpIntegrations = createAsyncThunk(
  "httpIntegration/fetchHttpIntegrations",
  async () => {
    const client = getAxiosClient();
    const response = await client.get(`api/http-integration`);
    return response.data as HttpIntegration[];
  }
);

export const fetchHttpIntegrationsById = createAsyncThunk(
  "httpIntegration/fetchHttpIntegrationsById",
  async (csId: string) => {
    const client = getAxiosClient();
    const response = await client.get(`api/http-integration/${csId}`);
    return response.data as HttpIntegration;
  }
);
